import { render, staticRenderFns } from "./tabBillPayment.vue?vue&type=template&id=267cba60&"
import script from "./tabBillPayment.vue?vue&type=script&lang=js&"
export * from "./tabBillPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('267cba60')) {
      api.createRecord('267cba60', component.options)
    } else {
      api.reload('267cba60', component.options)
    }
    module.hot.accept("./tabBillPayment.vue?vue&type=template&id=267cba60&", function () {
      api.rerender('267cba60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/BillPayment/siRui/tabBillPayment.vue"
export default component.exports